import { Loader } from 'lucide-react';

type SpinnerGlyphProps = {
  color: string;
  size?: number;
  strokeWidth?: number;
};

export function SpinnerGlyph({
  color,
  size = 18,
  strokeWidth = 2,
}: SpinnerGlyphProps) {
  return (
    <span
      className="tabbio-spinner-glyph"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        opacity: 0.92,
      }}
    >
      <Loader color={color} size={size} strokeWidth={strokeWidth} />
    </span>
  );
}
